import { render } from "./DonationRegistrationManagementDialog.vue?vue&type=template&id=0b06b3e9&scoped=true"
import script from "./DonationRegistrationManagementDialog.vue?vue&type=script&lang=js"
export * from "./DonationRegistrationManagementDialog.vue?vue&type=script&lang=js"

import "./DonationRegistrationManagementDialog.vue?vue&type=style&index=0&id=0b06b3e9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b06b3e9"]])

export default __exports__